import styles from "../../css/footer.module.css";

import icons from "../../css/icons.module.css";
export default function App() {
  

  <script src="https://unpkg.com/aos@2.3.1/dist/aos.js"></script>;
  return (
    <footer className={styles.footer}>
      <div className={styles.container}>


<div className={styles.containerLine}>

<div className={styles.line}>


</div>


<div className={styles.closeLabel}>

<p > Gracias por su visita</p>


</div>

<div className={styles.line}>


</div>




</div>
       



     
      </div>
    </footer>
  );
};
